export default "__VITE_ASSET__iZx_$ln___"